module.exports = __webpack_public_path__ + "img/download_icon_black.50c167b1.svg";